// extracted by mini-css-extract-plugin
export var content = "_ow-1";
export var fullScreen = "_ow-0";